import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader.component';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';

export function playerFactory() {
  return player;
}

@NgModule({
  imports: [CommonModule, LottieComponent, LoaderComponent],
  providers: [
    provideLottieOptions({
      player: playerFactory,
    }),
  ],
  exports: [LoaderComponent],
})
export class LoaderModule {}
